import { useEffect } from 'react';
import type { ConnectbaseNoticeStatus, ConnectbaseTaskKey } from '~/api/projectConnectbaseTasks';
import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import rootStore from '~/store';

// Keys already captured this session, so remounts (tab switches, layer panel reopen) don't re-count a message.
const shownNotices = new Set<string>();

export function resetShownNoticesForTest() {
  shownNotices.clear();
}

/** Captures `connectbase_status_message_shown` once per session per project, task and status. */
export function useStatusMessageShown(
  projectId: string,
  task: ConnectbaseTaskKey,
  status: ConnectbaseNoticeStatus | undefined,
) {
  useEffect(() => {
    if (!status) return;
    const key = `${projectId}:${task}:${status}`;
    if (shownNotices.has(key)) return;
    shownNotices.add(key);
    captureTypedPosthogEvent(POSTHOG_EVENTS.connectbaseStatusMessageShown, {
      project_id: projectId,
      organization_id: rootStore.currentOrganizationId || undefined,
      task,
      status,
    });
  }, [projectId, task, status]);
}
